import React from 'react';
import { Button, Modal, Text } from 'v3/components';
import moment from 'moment';
import { BodyContainer, FooterContainer } from './styles';

const ClearCellConfirmModal = ({
  isOpen,
  columnLabel,
  onConfirm,
  columnValue,
  onCancel
}) => {

  const validateColumnValue = (value) => {
    if (value === null || value === undefined) return 'vazio';
    if (Array.isArray(value)) return value.join(', ');
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (typeof value === 'object') return objsValues(value);
    return formatDateValue(value);
  }

  const objsValues = (value) => {
    return value?.name ||
      value?.label ||
      value?.description ||
      value?.social_name ||
      value?.socialName ||
      value?.username ||
      value?.plate ||
      value?.value ||
      value?.name ||
      'vazio';
  };


  const formatDateValue = (value) => {
    if (!value) return value;

    const date = moment(
      value,
      [
        'DD/MM/YYYY HH:mm',
        'YYYY-MM-DDTHH:mm:ss.SSSZ',
        'YYYY-MM-DDTHH:mm:ssZ',
        'YYYY-MM-DDTHH:mmZ',
        'YYYY-MM-DD',
      ],
      true
    );

    return date.isValid()
      ? date.format('DD/MM/YYYY HH:mm')
      : value;
  };

  return (
    <Modal
      show={isOpen}
      heading="Remover valor"
      body={
        <BodyContainer>
          <Text>{`Tem certeza que deseja remover o valor ${validateColumnValue(columnValue)} da coluna ${columnLabel}?`}</Text>
        </BodyContainer>
      }
      footer={
        <FooterContainer>
          <Button onClick={onCancel}>Cancelar</Button>
          <Button onClick={onConfirm}>Remover</Button>
        </FooterContainer>
      }
      handleClose={onCancel}
    />
  );
};

export default ClearCellConfirmModal;
